import { createFileRoute } from "@tanstack/react-router";
import BlogIndex from "@/pages/BlogIndex";
import { buildHead } from "@/lib/seo";

export const Route = createFileRoute("/blog/")({
  head: () =>
    buildHead({
      title:
        "Pool & Hardscape Blog | Outdoor Living Tips | Precision Pavers & Pool Design",
      description:
        "Expert advice, guides, and insights on pool remodeling, deck resurfacing, driveway pavers, travertine, marble, and outdoor living in South Florida.",
      path: "/blog",
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "Blog",
          name: "Precision Pavers & Pool Design Outdoor Living Blog",
          url: "https://precisionpaverspools.com/blog",
          description:
            "Expert advice on pool remodeling, resurfacing, pavers, and hardscaping in South Florida.",
        },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://precisionpaverspools.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Blog",
              item: "https://precisionpaverspools.com/blog",
            },
          ],
        },
      ],
    }),
  component: BlogIndex,
});
